import { User } from 'models/user/User';
import { ResponseDataRepository } from './ResponseDataRepository';

const UserRepositoryKey = 'THEME';

const UserRepository = new ResponseDataRepository<User>(UserRepositoryKey);

export default UserRepository;
